/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { ReactElement } from 'react';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import { RenderingCondition } from 'templates/pubSub/types/TemplateType';
import { NodeIdentifier } from 'utilities/PubSub/PubSubAddressSpace';
import { usePubSubNode, usePubSubValue } from 'utilities/PubSub/PubSubHooks';
import TemplateHelperPubSub from 'utilities/TemplateHelperPubSub';

interface IRenderOnConditionProps {
  templateContext: TemplateContext;
  condition?: RenderingCondition;
  startingNodeId?: NodeIdentifier;
  children: React.ReactNode | React.ReactNode[];
}

export default function RenderOnCondition(props: IRenderOnConditionProps): ReactElement {
  const filter = TemplateHelperPubSub.createFilter(
    props.templateContext.namespaces,
    props.condition?.valueVariable?.variablePath,
  );
  const node = usePubSubNode(filter, props.startingNodeId);
  const value = usePubSubValue(node);

  const text = TemplateHelperPubSub.formatVariableValue(value, props.condition?.valueVariable);

  if (props.condition && props.condition.values && !props.condition.values.includes(text)) {
    return <></>;
  }

  return <>{props.children}</>;
}
